module.exports = __webpack_public_path__ + "static/media/right-arw1.d3a77c5e.svg";